import { updateOnTopNavBarStoreUseCase } from "./updateOnTopUseCase";
import { UpdateNavBarStore } from "./updateOnTopUseCase";
import { isOnTop } from "../../domain/navBar/navBarModel";

const detectOnTopUseCase = (store: UpdateNavBarStore) => {
    return updateOnTopNavBarStoreUseCase(store, isOnTop);
}

export { detectOnTopUseCase }
